/**
 * @nubeteck/formeck (0.19.5)
 * Copyright (c) Nubeteck, SRL.
 */
import t from "react";
import { g as m, a as u } from "../chunks/currency-utils.DnRSwher.js";
import { useFormeckConfig as l } from "../contexts/formeck-config/formeck-config.js";
import "../contexts/stepper/stepper.js";
const b = () => {
  const { addConfig: c, currencyIso: e, decimalScale: a } = l(), r = m(`${e}`), n = t.useCallback(
    (o) => u(o, a).format({
      symbol: r
    }),
    [r, a]
  ), s = t.useCallback(
    (o) => c("currencyIso", o),
    [c]
  );
  return {
    currencySymbol: r,
    iso: e,
    formatValue: n,
    symbol: r,
    changeCurrencyIso: s
  };
};
export {
  b as default
};
